export const configSMTP = (state) => state.configSMTP;

export const configSMS = (state) => state.configSMS;

export const email = (state) => state.email;

export const sms = (state) => state.sms;

export const loadingNotifications = (state) => state.loadingNotifications;
